<template>
	<div 
		:class="[
			indeterminate ? 'loading' : 'car-container',
		]">
		<button type="button" @click="clicked">
			<svg xmlns="http://www.w3.org/2000/svg" width="32" height="24" viewBox="0 0 32 24">
				<g v-if="!indeterminate" :fill="`${globalColors.primary}`" fill-rule="nonzero" stroke-width="1">
					<path d="M14.182 12a.55.55 0 0 0 .554-.546.55.55 0 0 0-.554-.546.55.55 0 0 0-.554.546.55.55 0 0 0 .554.545z"/>
            		<path d="M26.148 7.636h-3.276L17.832.809A1.679 1.679 0 0 0 15.59.205a1.623 1.623 0 0 0-.645 2.226.555.555 0 0 0 .043.064l3.952 5.14H9.423l3.953-5.14a.584.584 0 0 0 .043-.064 1.623 1.623 0 0 0-.646-2.226 1.68 1.68 0 0 0-2.241.604l-5.04 6.827H2.216C.994 7.636 0 8.615 0 9.818c0 .948.625 1.774 1.506 2.067a.557.557 0 0 0 .34.114.549.549 0 0 1 .545.448l1.884 10.209a1.655 1.655 0 0 0 1.635 1.343h16.543c.804 0 1.492-.565 1.635-1.343l1.885-10.209a.549.549 0 0 1 .545-.448.556.556 0 0 0 .341-.116 2.19 2.19 0 0 0 1.505-2.065c0-1.203-.994-2.182-2.216-2.182zm-10.25-5.764a.54.54 0 0 1 .23-.712.56.56 0 0 1 .754.21c.01.02.023.038.036.056l4.584 6.21H20.33l-4.432-5.764zm-4.452-.446a.584.584 0 0 0 .036-.055.56.56 0 0 1 .753-.212.54.54 0 0 1 .23.713L8.034 7.636H6.862l4.584-6.21zm14.702 9.482h-9.75a.55.55 0 0 0-.554.546c0 .301.248.54.554.54h8.553a1.636 1.636 0 0 0-.068.253L22.998 22.46a.551.551 0 0 1-.545.447H5.91a.552.552 0 0 1-.545-.447L3.481 12.25A1.627 1.627 0 0 0 3.413 12h8.553a.55.55 0 0 0 .554-.545.55.55 0 0 0-.554-.546h-9.75a1.1 1.1 0 0 1-1.108-1.09 1.1 1.1 0 0 1 1.108-1.091h23.932a1.1 1.1 0 0 1 1.108 1.09c0 .606-.504 1.091-1.108 1.091z"/>
            		<path d="M14.182 13.636c-.917 0-1.662.734-1.662 1.636v4.364c0 .902.745 1.636 1.662 1.636.916 0 1.662-.734 1.662-1.636v-4.364c0-.904-.744-1.636-1.662-1.636zm.554 6a.55.55 0 0 1-.554.545.55.55 0 0 1-.554-.545v-4.364c0-.3.248-.545.554-.545a.55.55 0 0 1 .554.545v4.364zM19.722 21.272c.916 0 1.662-.734 1.662-1.636v-4.364c0-.904-.744-1.636-1.662-1.636-.917 0-1.662.734-1.662 1.636v4.364c0 .902.745 1.636 1.662 1.636zm-.554-6c0-.3.248-.545.554-.545a.55.55 0 0 1 .554.545v4.364a.55.55 0 0 1-.554.545.55.55 0 0 1-.554-.545v-4.364zM8.642 13.636c-.916 0-1.662.734-1.662 1.636v4.364c0 .902.746 1.636 1.662 1.636.916 0 1.662-.734 1.662-1.636v-4.364c0-.904-.744-1.636-1.662-1.636zm.554 6a.55.55 0 0 1-.554.545.55.55 0 0 1-.554-.545v-4.364c0-.3.248-.545.554-.545a.55.55 0 0 1 .554.545v4.364z"/>
				</g>
			</svg>
		</button>
		<output
			v-if="count"
			class="car-count"
			:style="`background-color:${globalColors.primary}`"
		>{{count}}</output>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';

function clicked() {
	this.$emit('click');
}
export default {
	name: 'camera-component',
	computed: {
		...mapGetters([
			'indeterminate',
		]),
	},
	methods: {
		clicked,
	},
	props: {
		count: {
			type: Number,
			default: 0,
		},
	},
};
</script>
<style lang="scss" scoped>
	.car-container {
		position: relative;
	}

	button {
		align-items: center;
		display: flex;
		justify-content: center;
	}

	.car-count {
		align-items: flex-end;
		border-radius: 50%;
		bottom: 70%;
		color: white;
		display: flex;
		font-family: font(bold);
		font-size: size(xsmall);
		height: 16px;
		justify-content: center;
		left: 60%;
		position: absolute;
		width: 16px;
	}
</style>



// WEBPACK FOOTER //
// src/components/shared/icons/car-component.vue